import pathfinder from '@fiverr-private/pathfinder';
import {
    BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    BQ_POPULAR_SERVICE_CLICK_BOOK_PUBLISHING,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC,
    BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
} from '../../utils/biEvents/events/bigQueryEvents';

interface PopularService {
    elementName: string;
    labelKey: string;
    href: string;
    eventName: string;
    isNew?: boolean;
}

const HEADER_LOHP_SOURCE = 'header_lohp';

export const DEFAULT_POPULAR_SERVICES: PopularService[] = [
    {
        elementName: 'website development',
        labelKey: 'logged_out_homepage.subcategory_carousel.website_development.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
    },
    {
        elementName: 'architecture & interior design',
        labelKey: 'logged_out_homepage.subcategory_carousel.architectural_design_services.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    },
    {
        elementName: 'UGC videos',
        labelKey: 'logged_out_homepage.subcategory_carousel.ugc_video.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'ugc-videos' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC,
    },
    {
        elementName: 'video editing',
        labelKey: 'logged_out_homepage.subcategory_carousel.video_editing.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'video-editing' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    },
    {
        elementName: 'book publishing',
        labelKey: 'logged_out_homepage.subcategory_carousel.book_publishing.sub',
        href: pathfinder(
            'content_pages_page',
            { page_slug: 'books-publishing' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_BOOK_PUBLISHING,
    },
];
